import React, { Component } from "react";
import Slider from "react-slick";

import slide0 from "../../assets/slide0.jpg";
import slide1 from "../../assets/slide1.jpg";
import slide2 from "../../assets/slide2.jpg";
import slide3 from "../../assets/slide3.jpg";
import slide4 from "../../assets/slide4.jpg";
import slide5 from "../../assets/slide5.jpg";

export default class ReactSlider extends Component {
  render() {
    var settings = {
      className: "inner-slide",
      dots: false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      accessibility: true,
      autoplay: true,
      speed: 2000,
      autoplaySpeed: 2000,
      // adaptiveHeight: true,
      //   cssEase: "linear",
      responsive: [
        // {
        //   breakpoint: 1024,
        //   settings: {
        //     slidesToShow: 3,
        //     slidesToScroll: 3,
        //     infinite: true,
        //     dots: true,
        //   },
        // },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            initialSlide: 2,
          },
        },
        {
          breakpoint: 555,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    return (
      <div>
        <Slider {...settings}>
          <div className="slide">
            <div className="image" id="purple">
              <img src={slide0} width="391" height="511" alt="Purple" />
            </div>
            <div className="text">
              <p>
                Our expert trainers and nutritionists at IGLF offer personalized
                healthy lifestyle coaching to help you hack your fitness regime.
                Offering 6 and 12 week programs to accommodate your schedule,
                our certified fitness coaches partner with you to devise a
                health and wellness routine that matches your goals.{" "}
              </p>
            </div>
          </div>

          <div className="slide">
            <div className="image">
              <img src={slide1} width="391" height="511" alt="Woman laptop" />
            </div>
            <div className="bottom">
              <button className="bottom-button">Wellness Assessment</button>
            </div>
          </div>

          <div className="slide">
            <div className="image">
              <img src={slide2} width="391" height="511" alt="Man on treadmill" />
            </div>
            <div className="bottom">
              <button className="bottom-button">Metabolic Testing</button>
            </div>
          </div>

          <div className="slide">
            <div className="image">
              <img src={slide3} width="391" height="511" alt="Woman with cereal" />
            </div>
            <div className="bottom">
              <button className="bottom-button">Nutrition</button>
            </div>
          </div>

          <div className="slide">
            <div className="image">
              <img src={slide4}width="391" height="511" alt="Women exercising" />
            </div>
            <div className="bottom">
              <button className="bottom-button">Personal Training</button>
            </div>
          </div>

          <div className="slide">
            <div className="image">
              <img src={slide5} width="391" height="511" alt="Couple at mountains" />
              <div className="bottom">
                <button className="bottom-button">Wellness Portal</button>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    );
  }
}
